import { EventEmitter } from "events";
const toastEmitter = new EventEmitter();
export const registerToastListener = (fn) => {
    const handler = (message, type) => fn(message, type);
    toastEmitter.on('toast', handler);
    return () => {
        toastEmitter.off('toast', handler);
    };
};
export const toast = {
    success: (msg) => toastEmitter.emit('toast', msg, 'success'),
    error: (msg) => toastEmitter.emit('toast', msg, 'error'),
    warning: (msg) => toastEmitter.emit('toast', msg, 'warning'),
    info: (msg) => toastEmitter.emit('toast', msg, 'info'),
};
